import { render, staticRenderFns } from "./AddProductDeptsComponent.vue?vue&type=template&id=487a607b&scoped=true"
import script from "./AddProductDeptsComponent.vue?vue&type=script&lang=js"
export * from "./AddProductDeptsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a607b",
  null
  
)

export default component.exports